import styled from 'styled-components';

const ListWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 0px 24px 16px 24px;
`;

export default ListWrapper;
